<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'Publish policy' | translate}}</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.close()"></button>
</div>
<div class="modal-body">
    <label class="label-block">
        {{'Version number' | translate}}
        <span class="text-muted ">{{'The version number of this policy' | translate}}</span>
        <input type="text" class="form-control" placeholder="eg: 1.1.0" [(ngModel)]="version"/>
    </label>
</div>
<div class="modal-footer">
    <button type="button" (click)="publish()" title="close" class="btn btn-primary btn-sm">
        <i class="fas fa-upload"></i> {{'Publish' | translate}}
    </button>
    <button type="button" (click)="modal.close()" title="close" class="btn btn-secondary btn-sm">
        <i class="far fa-times-circle"></i> {{'Close' | translate}}
    </button>
</div>
